// extracted by mini-css-extract-plugin
export default {"AssessmentListPage":"AssessmentList_AssessmentListPage__o4b3K"};